import React from 'react';
import styles from './SuggestionsMessage.module.scss';
import { SparkleMessage } from 'concepts/AutoDocExtraction/SparkleMessage/SparkleMessage';
import usePersistedState from 'hooks/usePersistedState';

export const SUGGESTIONS_MESSAGE_STORAGE_KEY =
  'showDe2TemplateSuggestionsMessage';

export const SuggestionsMessage = () => {
  const [show, setShow] = usePersistedState<boolean>(
    SUGGESTIONS_MESSAGE_STORAGE_KEY,
    true
  );

  if (!show) return null;

  return (
    <SparkleMessage
      dismissible={true}
      onClose={() => setShow(false)}
      className={styles.suggestionsMessage}
      iconStyle="solid"
    />
  );
};
